module.exports = __webpack_public_path__ + "static/media/logo-bbc-introducing-2.0fa3cc28.svg";